// based loosely on https://www.npmjs.com/package/timezones.json.  listings
// condensed,revised based on tz database; should not be used when "official"
// offsets matter, or for changes based on daylight-savings observances

export const timezones = [
  {
    shortName: "TZ",
    abbr: "TZ",
    longName: "Select a timezone..."
  },
  {
    shortName: "Hawaii Time",
    abbr: "HST",
    offset: -10,
    longName: "(GMT-10:00) Hawaii"
  },
  {
    shortName: "Alaska Time",
    abbr: "AKST",
    offset: -9,
    longName: "(GMT-09:00) Alaska"
  },
  {
    shortName: "Pacific Time",
    abbr: "PST",
    offset: -8,
    longName: "(GMT-08:00) Pacific Time (US & Canada)"
  },
  {
    shortName: "Mountain Time",
    abbr: "UMST",
    offset: -7,
    longName: "(GMT-07:00) Arizona"
  },
  {
    shortName: "Mountain Time",
    abbr: "MST",
    offset: -7,
    longName: "(GMT-07:00) Mountain Time (US & Canada)"
  },
  {
    shortName: "Central Time",
    abbr: "CST",
    offset: -6,
    longName: "(GMT-06:00) Central Time (US & Canada)"
  },
  {
    shortName: "Eastern Time",
    abbr: "EST",
    offset: -5,
    longName: "(GMT-05:00) Eastern Time (US & Canada)"
  },
  {
    shortName: "Eastern Time",
    abbr: "EST",
    offset: -5,
    longName: "(GMT-05:00) Indiana"
  },
  {
    shortName: "Dateline Standard Time",
    abbr: "DST",
    offset: -12,
    longName: "(GMT-12:00) International Date Line West"
  },
  {
    shortName: "Samoa Time",
    abbr: "SST",
    offset: -11,
    longName: "(GMT-11:00) Midway Island"
  },
  {
    shortName: "Mountain Time",
    abbr: "MST",
    offset: -7,
    longName: "(GMT-07:00) Chihuahua, La Paz, Mazatlan"
  },
  {
    shortName: "Central Time",
    abbr: "CST",
    offset: -6,
    longName: "(GMT-06:00) Central America"
  },
  {
    shortName: "Central Time",
    abbr: "CST",
    offset: -6,
    longName: "(GMT-06:00) Guadalajara, Mexico City, Monterrey"
  },
  {
    shortName: "Central Time",
    abbr: "CST",
    offset: -6,
    longName: "(GMT-06:00) Saskatchewan"
  },
  {
    shortName: "Colombia Time",
    abbr: "COT",
    offset: -5,
    longName: "(GMT-05:00) Bogota"
  },
  {
    shortName: "Peru Time",
    abbr: "PET",
    offset: -5,
    longName: "(GMT-05:00) Lima"
  },
  {
    shortName: "Ecuador Time",
    abbr: "ECT",
    offset: -5,
    longName: "(GMT-05:00) Quito"
  },
  {
    shortName: "Atlantic Time",
    abbr: "AST",
    offset: -4,
    longName: "(GMT-04:00) Atlantic Time"
  },
  {
    shortName: "Venezuela Time",
    abbr: "VET",
    offset: -4,
    longName: "(GMT-04:00) Caracas"
  },
  {
    shortName: "Chile Time",
    abbr: "CLT",
    offset: -4,
    longName: "(GMT-04:00) Santiago"
  },
  {
    shortName: "Newfoundland Time",
    abbr: "NT",
    offset: -3.5,
    longName: "(GMT-03:30) Newfoundland"
  },
  {
    shortName: "Brasilia Time",
    abbr: "BRT",
    offset: -3,
    longName: "(GMT-03:00) Brasilia"
  },
  {
    shortName: "Argentina Time",
    abbr: "ART",
    offset: -3,
    longName: "(GMT-03:00) Buenos Aires"
  },
  {
    shortName: "Greenland Time",
    abbr: "GST",
    offset: -3,
    longName: "(GMT-03:00) Greenland"
  },
  {
    shortName: "Uruguay Time",
    abbr: "UYT",
    offset: -3,
    longName: "(GMT-03:00) Montevideo"
  },
  {
    shortName: "Azores Time",
    abbr: "AZOT",
    offset: -1,
    longName: "(GMT-01:00) Azores"
  },
  {
    shortName: "Cape Verde Time",
    abbr: "CVT",
    offset: -1,
    longName: "(GMT-01:00) Cape Verde Is."
  },
  {
    shortName: "Greenwich Mean Time",
    abbr: "GMT",
    offset: 0,
    longName: "(GMT) Dublin, London"
  },
  {
    shortName: "UTC",
    abbr: "UTC",
    offset: 0,
    longName: "(UTC) Coordinated Universal Time"
  },
  {
    shortName: "Western European Time",
    abbr: "WET",
    offset: 0,
    longName: "(GMT) Lisbon, Reykjavik"
  },
  {
    shortName: "Central European Time",
    abbr: "CET",
    offset: 1,
    longName: "(GMT+01:00) Madrid, Rome, Stockholm, Prague"
  },
  {
    shortName: "Eastern European Time",
    abbr: "EET",
    offset: 2,
    longName: "(GMT+02:00) Athens, Bucharest, Cairo"
  },
  {
    shortName: "South Africa Time",
    abbr: "SAST",
    offset: 2,
    longName: "(GMT+02:00) Harare, Pretoria"
  },
  {
    shortName: "Turkey Time",
    abbr: "TRT",
    offset: 3,
    longName: "(GMT+03:00) Istanbul"
  },
  {
    shortName: "Israel Time",
    abbr: "IST",
    offset: 2,
    longName: "(GMT+02:00) Jerusalem"
  },
  {
    shortName: "Arabia Time",
    abbr: "AST",
    offset: 3,
    longName: "(GMT+03:00) Baghdad, Kuwait, Riyadh"
  },
  {
    shortName: "East Africa Time",
    abbr: "EAT",
    offset: 3,
    longName: "(GMT+03:00) Nairobi"
  },
  {
    shortName: "Moscow Time",
    abbr: "MSK",
    offset: 3,
    longName: "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
  },
  {
    shortName: "Samara Time",
    abbr: "SAMT",
    offset: 4,
    longName: "(GMT+04:00) Samara, Ulyanovsk, Saratov"
  },
  {
    shortName: "Iran Time",
    abbr: "IRST",
    offset: 3.5,
    longName: "(GMT+03:30) Tehran"
  },
  {
    shortName: "Pakistan Time",
    abbr: "PKT",
    offset: 5,
    longName: "(GMT+05:00) Islamabad, Karachi"
  },
  {
    shortName: "India Time",
    abbr: "IST",
    offset: 5.5,
    longName: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi"
  },
  {
    shortName: "Indochina Time",
    abbr: "ICT",
    offset: 7,
    longName: "(GMT+07:00) Bangkok, Hanoi, Jakarta"
  },
  {
    shortName: "China Time",
    abbr: "CST",
    offset: 8,
    longName: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi"
  },
  {
    shortName: "Singapore Time",
    abbr: "SST",
    offset: 8,
    longName: "(GMT+08:00) Kuala Lumpur, Singapore"
  },
  {
    shortName: "Taipei Time",
    abbr: "TST",
    offset: 8,
    longName: "(GMT+08:00) Taipei"
  },
  {
    shortName: "Japan Time",
    abbr: "JST",
    offset: 9,
    longName: "(GMT+09:00) Osaka, Sapporo, Tokyo"
  },
  {
    shortName: "Korea Time",
    abbr: "KST",
    offset: 9,
    longName: "(GMT+09:00) Seoul"
  },
  {
    shortName: "Australian Western Time",
    abbr: "AWST",
    offset: 8,
    longName: "(GMT+08:00) Perth"
  },
  {
    shortName: "Australian Central Time",
    abbr: "ACST",
    offset: 9.5,
    longName: "(GMT+09:30) Adelaide"
  },
  {
    shortName: "Australian Eastern Time",
    abbr: "AEST",
    offset: 10,
    longName: "(GMT+10:00) Canberra, Melbourne, Sydney"
  },
  {
    shortName: "Chamorro Time",
    abbr: "CHST",
    offset: 10,
    longName: "(GMT+10:00) Guam, Port Moresby"
  },
  {
    shortName: "New Zealand Time",
    abbr: "NZST",
    offset: 12,
    longName: "(GMT+12:00) Auckland, Wellington"
  },
  {
    shortName: "Fiji Time",
    abbr: "FJT",
    offset: 12,
    longName: "(UTC+12:00) Fiji"
  }
]

export const shortName = timezone => {
  return timezones.find(tz => tz.longName == timezone).shortName
}
